/* prettier-ignore */
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import IconButton from "@mui/material/IconButton";
import cn from "classnames";
import styles from "./CardCarousel.module.scss";

interface CardCarouselButtonsProps {
  nextClassName: string;
  prevClassName: string;
  beginOrEnd: "begin" | "end" | undefined;
  className?: string;
  buttonClasses?: {
    prev?: string;
    next?: string;
  };
}

function CardCarouselButtons({ prevClassName, nextClassName, beginOrEnd, className, buttonClasses }: CardCarouselButtonsProps) {
  return (
    <div className={cn(styles.buttonsContainer, className)}>
      <IconButton
        id={prevClassName}
        aria-label="Back Button"
        className={buttonClasses?.prev}
      >
        <ArrowBackIcon color={beginOrEnd === "begin" ? "inherit" : "primary"} />
      </IconButton>
      <IconButton
        id={nextClassName}
        aria-label="Forward Button"
        className={buttonClasses?.next}
      >
        <ArrowForwardIcon color={beginOrEnd === "end" ? "inherit" : "primary"} />
      </IconButton>
    </div>
  );
}

export default CardCarouselButtons;
